import React, { useState } from 'react';
import { svgs } from 'constants';

const features = [
    { icon: svgs.unlimited_sport, text: 'Unlimited Sports Books', bg_color: '#F5A623' },
    { icon: svgs.just_platform, text: 'Get More than just Platform', bg_color: '#00CD85' },
    { icon: svgs.localize, text: 'Localize Efficiently', bg_color: '#38B4DC' },
    { icon: svgs.casino_collection, text: 'Massive Casino Collection', bg_color: '#FF6441' },
    { icon: svgs.grow_faster, text: 'Grow Faster', bg_color: '#10AA43' },
    { icon: svgs.hustle, text: 'Forget The Hustle', bg_color: '#CF69FF' },
];

const AdminWhiteLabel = () => {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    return (
        <div className='admin-white-label-box w-full sm:w-[390px]'>
            <div className='casino-img-bg'></div>
            <div className='overlay'></div>

            <p className='awl-heading'>Why Use Admin Panel & White Label</p>

            <div className='grid grid-cols-2 gap-2 mx-2 awl-grid'>
                {features.map(({ icon, text, bg_color }, index) => (
                    <div className='awl-grid-item-outer' key={index}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <div className={`awl-grid-item `}
                            style={{
                                background: `${hoveredIndex === index ? `${bg_color}` : '#ffffff'}`,
                                borderColor: `${hoveredIndex === index ? `${bg_color}` : '#ffffff'}`
                            }} >
                            <div className='awl-grid-item-div'>
                                <div className='awl-svg'>{icon}</div>
                                <div className='para-div'>
                                    <p>{text}</p>

                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div >
    );
}

export default AdminWhiteLabel;